import { FormattedDate, FormattedMessage } from 'react-intl';
import { useGetSubscription } from 'store/subscription/actions';

export const CancelSubscriptionBanner = () => {
  const { data: subscription, isError } = useGetSubscription();

  if (isError) return null;

  const activeSubscription = subscription?.subscriptions.find(
    (sub) => sub.product_type.toLowerCase() === 'menu',
  );

  return (
    <div className="flex items-center gap-x-6 bg-gray-900 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <p className="text-sm leading-6 text-white">
        <div>
          <strong className="font-semibold">
            <FormattedMessage id="yourSubscriptionOnCancel" />{' '}
            <FormattedDate
              year="numeric"
              month="long"
              day="2-digit"
              value={(activeSubscription?.next_payment_date || 0) * 1000}
            />
          </strong>
        </div>
      </p>
      <div className="flex flex-1 justify-end"></div>
    </div>
  );
};
